export default {
    slug: 'reports',
    ability: 'reports',
    routes: [
        {
            path: 'reports',
            name: 'reports',
            component: () => import('@modules/Reports/Resources/js/pages/Index.vue')
        }
    ],
    nav: () => ({
        section: 'bottom',
        items: [
            {
                position: 2,
                title: i18n.t('Reports'),
                icon: 'file-chart',
                to: { name: 'reports' }
            }
        ]
    })
};
